import React from "react";
import "./Footer.css";

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <p>
        © {currentYear} <strong>Dwhite Development</strong>. All Rights
        Reserved.
      </p>

      <div className="footer-links">
        <a
          href="https://twitter.com/DeJuanWhite81"
          target="_blank"
          rel="noopener noreferrer"
        >
          Twitter
        </a>
        <a
          href="https://www.linkedin.com/in/DeJuanWhite"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        <a
          href="https://mail.google.com/mail/?view=cm&to=dwhite.dev01@gmail.com&su=Project%20Inquiry&body=Hi%20DeJuan,%0A%0AI%27m%20reaching%20out%20about%20a%20potential%20project.%20Let%20me%20know%20a%20good%20time%20to%20connect!"
          target="_blank"
          rel="noopener noreferrer"
        >
          Email
        </a>
      </div>

      <p className="footer-tagline">
        💻 Building full-stack experiences that work hard and look good doing
        it.
      </p>
    </footer>
  );
}

export default Footer;
